import { Editor } from 'slate';
import { setListItemCheckbox } from './setListItemCheckbox';
import { isTopLevelSelected } from './isTopLevelSelected';
import { moveTopLevelElement } from './moveTopLevelElement';
import { indent, maybeBackspaceListItem } from './indent';
export const TasquetMarkdownEditor = {
    ...Editor,
    setListItemCheckbox,
    isTopLevelSelected,
    moveTopLevelElement,
    indent,
    maybeBackspaceListItem,
};
//# sourceMappingURL=index.js.map